
namespace GeniuzPOS.Points {

    @Serenity.Decorators.registerClass()
    export class PrPointCampaignGrid extends Serenity.EntityGrid<PrPointCampaignRow, any> {
        protected getColumnsKey() { return PrPointCampaignColumns.columnsKey; }
        protected getDialogType() { return PrPointCampaignDialog; }
        protected getIdProperty() { return PrPointCampaignRow.idProperty; }
        protected getInsertPermission() { return PrPointCampaignRow.insertPermission; }
        protected getLocalTextPrefix() { return PrPointCampaignRow.localTextPrefix; }
        protected getService() { return PrPointCampaignService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
        
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")
        
        
            
            return buttons;
        }

        // protected createSlickGrid() {
        //     this.slickGrid = super.createSlickGrid();

        //     new Serenity.AutoColumnWidthMixin({
        //         grid: this
        //     });

        //     return this.slickGrid;
        // }
    }
}